var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWestfieldSuiteinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M11 46.188c-2.31-.688-4-2.882-4-5.482C7 37.555 9.482 35 12.543 35s5.544 2.555 5.544 5.706q-.002.669-.143 1.294h29.435a5.8 5.8 0 0 1-.466-2.294c0-3.151 2.482-5.706 5.544-5.706S58 36.555 58 39.706c0 2.275-1.293 4.24-3.164 5.156A4 4 0 0 1 55 46v3a4 4 0 0 1-4 4H15a4 4 0 0 1-4-4zM55 30v4.088M11 30v5m0-6q0-.243.014-.48C11.167 25.984 12.57 24 16 24h34c3.645 0 5 2.239 5 5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 36h32"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M22 53v4a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-4zm31 0v4a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-4zM41.25 5h7.5L50 12H40zM45 12v12"
}))));
export default SvgWestfieldSuiteinline;